export default __webpack_public_path__ + "static/media/inner-fof-leadership.64dece91.svg";